import React, { useState, useEffect } from 'react';
import {
    Box,
    TextField,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    Paper, CircularProgress, ListItemIcon, IconButton,
} from '@mui/material';
import {defaultVariables} from "../../../../../config";
import axios from "axios";
import RayaField from "../../../../components/elements/fields/RayaField";
import InputAdornment from "@mui/material/InputAdornment";
import {Search,History} from "lucide-react";
import TypingText from "../../../../components/elements/TypingText";
import {useNavigate} from "react-router-dom";

const MainSearchField = ({industry,search = ''}) => {
    const [query, setQuery] = useState(search);
    const [suggestions, setSuggestions] = useState([]);
    const [placeholder, setPlaceholder] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [searchHistory, setSearchHistory] = useState([]); // State to store search history
    const navigation = useNavigate();

    let debounceTimeout = null;
    const config = {
        headers: {
            Accept: 'application/json',
        },
    };

    // Save search history to localStorage whenever it changes
    useEffect(() => {
        if(!! searchHistory?.length){
            localStorage.setItem('searchHistory', JSON.stringify(searchHistory));
        }
    }, [searchHistory]);

    useEffect(() => {
        setQuery(search)
    }, [search]);

    // Fetch suggestions from the server
    const fetchSuggestions = async (value) => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${defaultVariables.url}/search/suggestion/${industry}/${encodeURIComponent(value)}`,config);
            setSuggestions(response.data);
        } catch (error) {
            console.error('Error fetching suggestions:', error);
        } finally {
            setIsLoading(false);
        }
    };

    // Handle input change with debounce
    const handleInputChange = (event) => {
        const value = event.target.value;
        setQuery(value);

        clearTimeout(debounceTimeout);

        if (value) {
            debounceTimeout = setTimeout(() => {
                fetchSuggestions(value);
            }, 300); // Adjust debounce delay as needed
        } else {
            setSuggestions([]);
        }
    };

    const handleQueryClick = (q) => {
        if (!q.trim()) return; // Prevent empty or whitespace-only queries

        // Update search history with non-empty queries only
        const updatedHistory = [q, ...searchHistory.filter(item => item !== q)].slice(0, 5);

        localStorage.setItem('searchHistory', JSON.stringify(updatedHistory)); // Save to localStorage
        setSearchHistory(updatedHistory); // Update state

        navigation(`/${industry}/search?q=${encodeURIComponent(q)}`);
        setSuggestions([]);
        setQuery(q);
    };

    const handleFocus = () => {
        const history = JSON.parse(localStorage.getItem('searchHistory') || '[]');
        setSearchHistory(history.filter(item => item.trim().length > 0)); // Filter out empty entries
    };

    const handleBlur = () => {
        setTimeout(function() {
            setSearchHistory([]);
            setSuggestions([]);
        }, 100);

    };

    const texts = [
        "Restoran Ara...",
        "Yemek Ara...",
        "Kategorilerde Ara...",
    ];

    return (
        <div className="main-search-holder">
            <form onSubmit={(e) => {
                e.preventDefault();
                handleQueryClick(query);
            }}>
                <RayaField
                    value={query}
                    onChange={handleInputChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                    autoComplete="off"
                    fullWidth
                    placeholder={placeholder}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    {
                                        isLoading ?
                                            <CircularProgress size={14} color="text"/>
                                            :
                                            <IconButton onClick={() => handleQueryClick(query)}>
                                                <Search className="lucide-icon-primary lucide-large" />
                                            </IconButton>
                                    }
                                </InputAdornment>
                            ),
                        },
                    }}
                />
            </form>

            <TypingText
                texts={texts}
                speed={100}
                loop={true}
                onChange={setPlaceholder}
            />
            {(suggestions.length > 0 || searchHistory.length > 0) && (
                <Paper
                    elevation={3}
                    sx={{
                        position: 'absolute',
                        top: 'calc(100% + 8px)', // Add spacing below the input field
                        left: 0,
                        right: 0,
                        zIndex: 10,
                        maxHeight: 200,
                        overflowY: 'auto',
                        backgroundColor: 'white',
                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    }}
                >
                    <List>
                        {suggestions.map((suggestion, index) => (
                            <ListItem key={`suggestion-${index}`} disablePadding>
                                <ListItemButton onClick={() => handleQueryClick(suggestion)}>
                                    <ListItemIcon>
                                        <Search />
                                    </ListItemIcon>
                                    <ListItemText primary={suggestion} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                        {searchHistory.map((historyItem, index) => (

                            <ListItem key={`history-${index}`} disablePadding>
                                <ListItemButton onClick={() => handleQueryClick(historyItem)}>
                                    <ListItemIcon>
                                        <History />
                                    </ListItemIcon>
                                    <ListItemText primary={historyItem} />
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>
                </Paper>
            )}
        </div>
    );
};

export default MainSearchField;